import { render, staticRenderFns } from "./EmailHandler.vue?vue&type=template&id=063d7130"
import script from "./EmailHandler.vue?vue&type=script&lang=js"
export * from "./EmailHandler.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports